



















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class DataTitle extends Vue {
  @Prop() private formData: any;
  isShow = true; //默认表单提示
  private defaultText = ''; //默认表单提示文本
  //数据标题表单
  private dataTitle: any = {
    custom: '', // 自定义内容：{{控件id}} + 拼接文本
    value: '', // 默认（default）、自定义（customize）
  };
  /**
   * @desc 失去焦点
   */
  defaultBlur() {
    if (this.defaultText !== '') {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  }
  /**
   * @desc 聚焦
   */
  defaultFocus() {
    this.defaultText = '';
    this.isShow = false;
  }
  /**
   * @desc 监听表单数据 向父组件发送表单数据
   */
  @Watch('dataTitle', { deep: true })
  private getData() {
    const data = {
      dataTitle: this.dataTitle,
      type: 'data',
    };
    this.$emit('setFormData', data);
  }
  mounted() {
    this.dataTitle = this.formData.dataTitle;
  }
}
